<template>
  <div class="s1-U__full-width s1-U__align-children--center" v-if="user">
    <md-avatar class="md-avatar-icon md-primary s1-U__mg--rt8" :class="avatarSize || ''">
      <img :src="user.photo" alt="Avatar" v-if="user.photo">
      <md-ripple class="s1-U__text-uppercase" v-else>{{user.name.charAt(0) || user.nickname.charAt(0)}}</md-ripple>
    </md-avatar>
    <div class="s1-U__full-width s1-U__text-ellipsis" :title="user.nickname">
      <p
        class="s1-U__full-width s1-U__text-ellipsis"
        :title="user.name"
        v-if="user.name"
      >{{user.name}}</p>
      <p
        class="s1-U__full-width s1-U__text-ellipsis"
        :class="{'md-caption': user.name}"
        :title="user.nickname"
      >{{user.nickname}}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    avatarSize: String
  },
  computed: {
    ...mapGetters('user', {
      user: 'INFO'
    })
  }
}
</script>
